function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { CanvasView } from '@intercom/interblocks.ts';
export default class MessengerCardView {
  constructor(node, config) {
    _defineProperty(this, "dom", void 0);
    _defineProperty(this, "canvasView", void 0);
    this.dom = document.createElement('div');
    let innerDom = document.createElement('div');
    this.dom.appendChild(innerDom);
    this.dom.classList.add('embercom-prosemirror-composer-messenger-card');
    innerDom.classList.add('intercom-interblocks-messenger-card');
    if (!config.canvasNetworkClient) {
      throw new Error('You must specify a canvas networking client when using messenger cards');
    }
    this.canvasView = new CanvasView(innerDom, config.canvasNetworkClient, undefined, undefined, false, true, config.canvasLoadingImage);
    this.canvasView.render(node.attrs.canvas);
  }
  destroy() {
    this.canvasView.destroy();
  }
}